module.exports = __webpack_public_path__ + "img/food-27.9f14a32a.jpg";